(function () {
    'use strict';

    function functionsConfigurationDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/functionsconfiguration';

        function loadConfiguration() {
            return $http.get(baseUrl).then(function (response) {
                return response.data;
            });
        };

        return {
            loadConfiguration: loadConfiguration
        };
    }

    functionsConfigurationDataService.$inject = ['$http'];

    angular.module('ecap.common').service('functionsConfigurationDataService', functionsConfigurationDataService);
})();
